import { HalfDayType, HolidayDto, LeaveType } from "app/api/models";

export class HolidayUtilities {
    static getLeaveTypeName(type: number) {
        switch(type) {
            case LeaveType.Annual: return 'Annual Leave';
            case LeaveType.CarryOver: return 'Carry Over';
            case LeaveType.Compassionate: return 'Compassionate Leave';
            case LeaveType.EmployeeOfMonth: return 'Employee of the Month';
            case LeaveType.JuryService: return 'Jury Service';
            default: return LeaveType[type].toString();
        }
    }

    static getLeaveTypeColour(type: number) {
        switch(type) {
            case LeaveType.Annual: return 'rgb(86, 156, 167)';
            case LeaveType.Sickness: return '#aa8069';
            case LeaveType.Appointment: return '#bbdb64';
            case LeaveType.CarryOver: return '#a1a4d7';
            case LeaveType.Compassionate: return '#f1616c';
            case LeaveType.EmployeeOfMonth: return '#f2a133';
            case LeaveType.JuryService: return '#d28b92';
            case LeaveType.Training: return '#92b33c';
            case LeaveType.Unpaid: return '#a978d2';
            case LeaveType.Other: return '#718954';
            default: return 'grey';
        }
    }

    static getLeaveTypeIcon(type: number) {
        switch(type) {
            case LeaveType.Annual: return 'mat_solid:beach_access';
            case LeaveType.Sickness: return 'mat_solid:medical_services';
            // case LeaveType.BankHoliday: return 'googlefonts:globe-uk';
            case LeaveType.Appointment: return 'mat_solid:perm_contact_calendar';
            case LeaveType.CarryOver: return 'heroicons_solid:arrow-uturn-right';
            case LeaveType.Compassionate: return 'heroicons_solid:heart';
            case LeaveType.EmployeeOfMonth: return 'heroicons_solid:trophy';
            case LeaveType.JuryService: return 'mat_solid:gavel';
            case LeaveType.Training: return 'heroicons_solid:academic-cap';
            case LeaveType.Unpaid: return 'mat_solid:paid';
            case LeaveType.Other: return 'heroicons_solid:gift';

            default: return LeaveType[type].toString();
        }
    }
    
    static getDayCount(holiday: HolidayDto) {
        // Backend already calculates business days (excluding weekends/bank holidays)
        // and applies half-day adjustment, so just return the value directly
        return holiday.days;
    }
}
